// Word timings carried through the edits made to a track.
// The implementation lives in src/shared/alignEdit.js (CommonJS), shared with
// the server-side task runner; this file only re-exports it for the browser.
import * as shared from '../shared/alignEdit';

export const {
  cutWords, trimWords, insertWords, spliceWords, pieceWordsFrom, liveSpan,
  wordsForStorage, untouchedOrdinals, cutWordsMany,
} = shared;
